import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { NumberInput } from '@/components/ui/number-input';

export function RulesStep({ eventData, setEventData, generatedGameTimes }) {
  return (
    <div className="space-y-6 wizard-step">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="form-field">
          <Label className="text-slate-700 font-medium">Games per Day (per venue)</Label>
          <NumberInput data-testid="games-per-day-input" min={1} max={50} value={eventData.rules.games_per_day}
            onChange={(value) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, games_per_day: value } }))} className="mt-2" />
        </div>
        <div className="form-field stagger-1">
          <Label className="text-slate-700 font-medium">Game Duration (minutes)</Label>
          <NumberInput data-testid="game-duration-input" min={10} max={240} step={5} value={eventData.rules.game_duration}
            onChange={(value) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, game_duration: value } }))} className="mt-2" />
        </div>
        <div className="form-field stagger-2">
          <Label className="text-slate-700 font-medium">Buffer Time (minutes)</Label>
          <NumberInput data-testid="buffer-time-input" min={0} max={60} step={5} value={eventData.rules.buffer_time}
            onChange={(value) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, buffer_time: value } }))} className="mt-2" />
        </div>
        <div className="form-field stagger-3">
          <Label className="text-slate-700 font-medium">Min Rest Time (minutes)</Label>
          <NumberInput data-testid="rest-time-input" min={0} max={180} step={5} value={eventData.rules.min_rest_time}
            onChange={(value) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, min_rest_time: value } }))} className="mt-2" />
        </div>
      </div>

      <div className="form-field stagger-4">
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-slate-700 font-medium">No Back-to-Back Games</Label>
            <p className="text-sm text-slate-500">Prevent teams from playing consecutive games</p>
          </div>
          <Switch data-testid="no-back-to-back-switch" checked={eventData.rules.no_back_to_back}
            onCheckedChange={(checked) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, no_back_to_back: checked } }))} />
        </div>
      </div>

      <div className="form-field stagger-5">
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-slate-700 font-medium">Home/Away Designation</Label>
            <p className="text-sm text-slate-500">Mark teams as Home or Away for each match</p>
          </div>
          <Switch data-testid="home-away-switch" checked={eventData.rules.home_away_enabled}
            onCheckedChange={(checked) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, home_away_enabled: checked } }))} />
        </div>
      </div>

      <div className="form-field stagger-6">
        <Label className="text-slate-700 font-medium">First Game Start Time</Label>
        <p className="text-sm text-slate-500 mt-1 mb-2">Game times will be automatically calculated based on duration and buffer</p>
        <Input type="time" data-testid="first-game-time-input" value={eventData.rules.first_game_time}
          onChange={(e) => setEventData(prev => ({ ...prev, rules: { ...prev.rules, first_game_time: e.target.value } }))}
          className="mt-2 h-12 w-40" />
      </div>

      <div className="form-field stagger-7">
        <Label className="text-slate-700 font-medium mb-3 block">Generated Game Times</Label>
        <p className="text-sm text-slate-500 mb-3">Based on {eventData.rules.games_per_day} games/day, {eventData.rules.game_duration} min duration, {eventData.rules.buffer_time} min buffer</p>
        <div className="flex flex-wrap gap-2">
          {generatedGameTimes.map((time, i) => (
            <div key={i} className="px-4 py-2 bg-[#00247D]/10 text-[#00247D] rounded-lg font-medium">Game {i + 1}: {time}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
